import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ContentSource from './ContentSource'
import Login from './Login'
import { AppContainer, RouteNotFound, muiTheme, GoogleAnalytics } from 'j-comps'
import config from '../config'

const App = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={muiTheme(config.app)}>
      <GoogleAnalytics id={config.googleAnalyticsId} />
      <AppContainer>
        <Router>
          <Switch>
            <Route path="/" component={ContentSource} exact />
            <Route path="/login" component={Login} exact />
            <Route component={RouteNotFound} />
          </Switch>
        </Router>
      </AppContainer>
    </ThemeProvider>
  </StyledEngineProvider>
)

export default App
